"use strict";

/**
 * Show ad inside video list
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * @returns {boolean}
   */
  function isEnabled() {
    var _Flix$routeArgs$sort, _Flix$routeArgs$page;
    return Flix.ads.enabled
    // only for tna
    && Flix.isTna()
    /** Do not show on desktop */ && !FlixUtils.isDesktop()
    /** Do not show for organic users */ && !Flix.ads.isOrganic()
    /** Show only on the home page */ && Flix.currentRouteId == 'controllers.video.home'
    /** Only with default "featured" sort */ && ((_Flix$routeArgs$sort = Flix.routeArgs['sort']) !== null && _Flix$routeArgs$sort !== void 0 ? _Flix$routeArgs$sort : 'featured') == 'featured'
    /** Only on the 1st page */ && ((_Flix$routeArgs$page = Flix.routeArgs['page']) !== null && _Flix$routeArgs$page !== void 0 ? _Flix$routeArgs$page : 1) == 1
    // Should be enough videos in the list
    && !!document.querySelector('.video-list [data-num="3"]');
  }

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (Flix.isTna()) {
      /** Prepare Exo script */
      var s = document.createElement('script');
      s.src = 'https://a.realsrv.com/video-outstream.js';
      s.setAttribute('data-sub', Flix.ads.iid);
      s.setAttribute('data-idzone', 4506148);
      s.setAttribute('data-branding_enabled', 0);

      /** Prepare thumb and add Exo script inside */
      var thumb = document.createElement('div');
      thumb.dataset.nosnippet = true;
      thumb.className = 'col-xs-6 col-md-4 col-xl-3 mb-3';
      thumb.appendChild(s);

      /** Add thumb to on 4th place in video list */
      document.querySelector('.video-list [data-num="3"]').after(thumb);
    } else {
      /** Prepare Exo script */
      var s = document.createElement('script');
      s.src = 'https://a.realsrv.com/video-outstream.js';
      s.setAttribute('data-sub', Flix.ads.iid);
      s.setAttribute('data-idzone', 4506174);

      /** Prepare thumb and add Exo script inside */
      var thumb = document.createElement('div');
      thumb.dataset.nosnippet = true;
      thumb.className = 'col-xs-6 col-md-4 col-xl-3 mb-3';
      thumb.appendChild(s);

      /** Add thumb to on 4th place in video list */
      document.querySelector('.video-list [data-num="3"]').after(thumb);
    }
  }
})();